<template>
  <div
    :id="componentId"
    class="w-100 px-0 d-flex flex-row justify-content-between align-items-center mb-space-xs"
    :aria-labelledby="`${componentId}-title`"
  >
    <h3
      class="text-left"
      :class="titleClass"
      :id="`${componentId}-title`"
      :aria-hidden="false"
    >
      {{ title }}
    </h3>
  </div>

  <div
    v-for="(subject, index) in interestAreasWithNonNullSubjects"
    :key="subject.id"
    class="mb-space-xxs"
  >
    <CollapseSubjectAreas
      :options="subject"
      v-model="selectedSubjects"
      :componentId="`${componentId}-${index}-${subject.id}`"
      @checked="onChecked"
      @unchecked="onUnchecked"
      @change="onChange"
      @collapse:hidden="onHidden"
      @collapse:shown="onShown"
      :aria-labelledby="`${componentId}-title`"
      :aria-hidden="false"
    />
  </div>
</template>

<script lang="ts" setup>
import CollapseSubjectAreas from "~/components/degree-search/CollapseSubjectAreas.vue";
import { FilterInterestAreaSubjects } from "~/src/services/DegreeSearchService";
export type FilterNestedModel = {
  [key: string]: Set<string>;
};
export type NestedCheckFilterEmit = {
  section: string;
  text: string;
  checked: boolean;
};
export type NestedFilterCollapseEmit = {
  event: string;
  value: string;
};
/*
 ********************************************
 *  Emits
 ********************************************
 */
const emits = defineEmits<{
  (e: "checked", value: NestedCheckFilterEmit): void;
  (e: "unchecked", value: NestedCheckFilterEmit): void;
  (e: "change", value: NestedCheckFilterEmit): void;
  (e: "collapse:hidden", value: NestedFilterCollapseEmit): void;
  (e: "collapse:shown", value: NestedFilterCollapseEmit): void;
}>();

type Props = {
  title: string;
  titleSize?: string;
  titleVariant?: string;
  options: FilterInterestAreaSubjects[];
  componentId: string;
};

const props = withDefaults(defineProps<Props>(), {
  titleSize: "small",
  titleVariant: "dark-3",
});

const selectedSubjects = defineModel<FilterNestedModel>({});

/*
 ********************************************
 *  computed
 ********************************************
 */
const titleClass = computed(() => {
  return `h3-${props.titleSize} fs-${props.titleVariant}`;
});

const interestAreasWithNonNullSubjects = computed(() => {
  let interestAreaArray: FilterInterestAreaSubjects[] = [];
  interestAreaArray = props.options.filter(
    (option) => option.subjects.length > 0
  );
  return interestAreaArray;
});

/*
 ********************************************
 *  methods
 ********************************************
 */
const onChecked = (value: NestedCheckFilterEmit) => {
  emits("checked", value);
};
const onUnchecked = (value: NestedCheckFilterEmit) => {
  emits("unchecked", value);
};
const onChange = (value: NestedCheckFilterEmit) => {
  emits("change", value);
};
const onHidden = (value: NestedFilterCollapseEmit) => {
  emits("collapse:hidden", value);
};
const onShown = (value: NestedFilterCollapseEmit) => {
  emits("collapse:shown", value);
};
</script>

<style lang="scss" scoped></style>
~/src/services/DegreeSearchService
